export const styles = theme => ({
  root: {
    position: 'relative',
    overflowY: 'unset',
  },

  closeButton: {
    position: 'absolute',
    right: theme.spacing(3),
    top: theme.spacing(-2),
    zIndex: 999,
    minWidth: 0,
    width: 40,
  },

  photo: {
    backgroundColor: '#333',
    objectFit: 'scale-down',
    height: '100%',
    maxHeight: 380,
    width: '100%',
  },

  title: {
    margin: theme.spacing(2, 0),
    color: theme.palette.primary.dark,
    textAlign: 'center',
  },

  socialSection: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(0, 2),
  },

  icon: {
    color: '#bbb',
    display: 'block',
    marginBottom: theme.spacing(1),
    margin: theme.spacing(2.5, 4),
    width: 20,
    height: 20,
    // [theme.breakpoints.down('xs')]: {
    //   width: 15,
    //   height: 15,
    // },
  },

  iconLabel: {
    textAlign: 'center',
    fontWeight: 300,
    cursor: 'default',
    // [theme.breakpoints.down('xs')]: {
    //   fontSize: 12,
    // },
  },

  shareIcon: {
    margin: theme.spacing(0, 1),
    position: 'relative',
    top: theme.spacing(0.5),
    fontWeight: 300,
  },

  inappropriateContent: {
    marginTop: theme.spacing(3),
    fontSize: 12,
  },
})
